import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { TOOLS_COLLECTION } from '@dges/modules/portfolio/domain';
import { SNACKBAR_FACADE } from '@dges/modules/snackbar';
import * as ToolsActions from './tools.actions';
import { of, from } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

@Injectable()
export class ToolsEffects {
  private actions$ = inject(Actions);
  private angularFire = inject(TOOLS_COLLECTION);
  private snackBar = inject(SNACKBAR_FACADE);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToolsActions.init),
      switchMap(() =>
        this.angularFire.getTools().pipe(
          map((action) => {
            return ToolsActions.loadToolsSuccess({ tools: action });
          }),
          catchError((error) => of(ToolsActions.loadToolsFailure(error))),
        ),
      ),
    ),
  );

  public addTool$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToolsActions.addTool),
      switchMap((actionProps) =>
        from(this.angularFire.addTool(actionProps.tool)).pipe(
          map(() => {
            return ToolsActions.addToolSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(ToolsActions.addToolFail(error));
          }),
        ),
      ),
    ),
  );

  public deleteTool$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToolsActions.deleteTool),
      switchMap((actionProps) =>
        from(this.angularFire.deleteTool(actionProps.tool)).pipe(
          map(() => {
            return ToolsActions.deleteToolSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(ToolsActions.deleteToolFail(error));
          }),
        ),
      ),
    ),
  );

  public editTool$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToolsActions.editTool),
      switchMap((actionProps) =>
        from(this.angularFire.editTool(actionProps.tool)).pipe(
          map(() => {
            return ToolsActions.editToolSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(ToolsActions.editToolFail(error));
          }),
        ),
      ),
    ),
  );
}
